import React from 'react'
import {Badge, Tag} from "antd"

const configs = {
  0: ['#f2c358', ['待支付']],
  1: ['#3d93ec', ['已付款']],
  2: ['#87d068', ['已出票']],
  3: ['#87d068', ['已完成']],
  4: ['#7d7f9f', ['已取消']],
  5: ['#f50', ['已退票']],
  8: ['#7d7f9f', ['已关闭']],
}

const Status = ({
                  value,
                }) => {
  return (value === undefined || configs[value] === undefined) || <Tag color={configs[value][0]}>{configs[value][1]}</Tag>
}

export default Status

